<template>
<div class="hnw-zone">
    <GoodsInfo v-if="showGoodsDetail" ref="goodsInfoComponent" @hideInfo="hideGoodsDetail"></GoodsInfo>
    <div class="tab-container hnw-area-center" v-show="!showGoodsDetail">
        <div class="tab-header">
            
            <div 
                class="tab-item" 
                :class="{ active: activeTab === 'product' }" 
                @click="switchTab('product',1)"
            >
                产品中心
            </div>
            <div 
                class="tab-item" 
                :class="{ active: activeTab === 'newProduct' }" 
                @click="switchTab('newProduct',2)"
            >
                新产品中心
            </div>
            <div 
                class="tab-item" 
                :class="{ active: activeTab === 'poster' }" 
                @click="switchTab('poster',3)"
            >
                海报中心
            </div>
            <div 
                class="tab-item" 
                :class="{ active: activeTab === 'feedback' }" 
                @click="switchTab('feedback',4)"
            >
            
                反馈中心
            </div>
            <!-- 返回按钮，只在产品中心且showPartsList为true时显示 -->
            <div 
                v-if="activeTab === 'product' && showPartsList" 
                class="back-button" 
                @click="hidePartsList"
            >
                <i class="el-icon-arrow-left"></i> 返回
            </div>
        </div>
        
        <!-- 产品中心内容 -->
        <div v-show="activeTab === 'product'" class="tab-content">
            <PartList ref="partList" @update:showPartsList="handleShowPartsList" @showGoodsDetail="showGoodsDetailFromChild"></PartList>
        </div>
        
        <!-- 新产品中心内容 -->
        <div v-show="activeTab === 'newProduct'" class="tab-content">
            <NewPartList @showGoodsDetail="showGoodsDetailFromChild"></NewPartList>
        </div>
        
        <!-- 海报中心内容 -->
        <div v-if="activeTab === 'poster'" class="tab-content">
            <Poster></Poster>
        </div>
        
        <!-- 反馈中心内容 -->
        <div v-show="activeTab === 'feedback'" class="tab-content">
            <Feedback></Feedback>
        </div>
    </div>
</div>
</template>

<script>
import PartList from './partList.vue'
import NewPartList from './newPartList.vue'
import Poster from './poster.vue'
import Feedback from './feedback.vue'
import GoodsInfo from '../../components/GoodsInfo.vue'


export default {
    components: {
        PartList,
        NewPartList,
        Poster,
        Feedback,
        GoodsInfo
    },
    data(){
        return{
            activeTab: 'product', // 默认显示产品中心
            showPartsList: false, // 控制是否显示返回按钮
            showGoodsDetail: false
        }
    },
    methods:{
        // 切换tab
        switchTab(tab,module) {
            this.$api.getAnalysisLogNew({
                page: "hnwZone",
                module,
                click_count: 1
            })
            this.activeTab = tab;
            if (tab === 'feedback') {
                // this.$api.getUnreadMessage()
            }
        },
        // 处理showPartsList变化
        handleShowPartsList(value) {
            this.showPartsList = value;
        },
        // 隐藏产品列表，显示原始列表
        hidePartsList() {
            // 调用PartList组件的hidePartsList方法
            this.$refs.partList.hidePartsList();
        },
        // 从子组件显示商品详情
        showGoodsDetailFromChild(goods) {
            this.showGoodsDetail = true;
        },
        // 隐藏商品详情
        hideGoodsDetail() {
            this.showGoodsDetail = false;
        }
    },
    created(){
        // 判断是否是点击海报审核通知过来的 
        if (this.$route.query.from === 'posterApproved') {
            this.activeTab = 'poster';
        }
        if (this.$route.query.from === 'newProduct') {
            this.activeTab = 'newProduct';
        }
        this.$api.getAnalysisLogNew({
            page: "hnwZone",
            module: 1,
            click_count: 1
        })
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.hnw-zone{
    background: #F9F9F9;
    .tab-container {
        padding-top: 8px;
        .tab-header {
            display: flex;
            background: #fff;
            border-bottom: 1px solid #e4e4e4;
            padding: 6px 30px;
            .tab-item {
                padding: 12px 0;
                margin-right: 30px;
                cursor: pointer;
                font-size: 16px;
                color: #666;
                border-bottom: 2px solid transparent;
                &.active {
                    color: #3E84D6;
                    border-bottom: 2px solid #3E84D6;
                    font-weight: bold;
                }
            }
            .back-button {
                display: flex;
                align-items: center;
                padding: 12px 0;
                margin-left: 0;
                cursor: pointer;
                color: #409EFF;
                font-weight: bold;
                font-size: 16px;
            }
        }
        
        .tab-content {
            // padding: 20px;
            min-height: 400px;
        }
    }
}
</style>